export const Steps = ({ step, heading, text }) => {
  return (
    <>
      <div className="stepContainer py-5">
        <div className="championsTrophyStep">{step}</div>
        <div className="stepIcons">
          <img src="../images/championsTrophy/stepIcons.png" alt="" />
        </div>
        <div className="stepHeading mt-3">{heading}</div>
        <div className="stepTxt mt-2">{text}</div>
      </div>
    </>
  );
};
